import type { ResidentAppModuleConfig } from '../validations/residentAppModuleConfig'

export const LAUNDRY_CATEGORIES = [
  'washing_machine',
  'allergy_washing_machine',
  'dryer',
  'mangle',
  'laundry_room',
]

export const SAUNA_CATEGORIES = ['house_sauna', 'sauna_cabinet']

/**
 * Maps a reservable category to its corresponding module configuration.
 */
export const getCategoryModuleConfig = (
  category: string | undefined | null,
  moduleConfig: ResidentAppModuleConfig
) => {
  if (!category) return undefined

  if (LAUNDRY_CATEGORIES.includes(category)) {
    return moduleConfig.laundryReservation
  }

  if (SAUNA_CATEGORIES.includes(category)) {
    return moduleConfig.sauna
  }

  if (category === 'reservable_common_area') {
    return moduleConfig.commonAreaReservations
  }

  if (category === 'gym') {
    return moduleConfig.gymReservations
  }

  return undefined
}
